import { Inject, Injectable, Optional } from "@angular/core";

import { CORE_CONFIG } from "./const";
import { AlternateDomainConfigModel, CoreConfigModel } from "./model";

@Injectable({
	providedIn: "root",
})
export class CoreConfig implements CoreConfigModel {
	isBot?: boolean;
	isOptimizelyEnabled?: boolean;
	isFullStoryEnabled?: boolean;
	isParadomeEnabled?: boolean;
	isAppleIconDisabled?: boolean;
	isHeapEnabled?: boolean;
	isPrimaryDomain = true;
	isCrawlableForCurrentMarket = true;
	activeExperiments: string[] = [];
	blockDomainMarkets: string[] = ["pl"];
	alternateDomains?: AlternateDomainConfigModel[];
	isNative?: boolean;
	isB2b?: boolean;
	frameAncestors?: string;
	userContext?: Record<string, string>;
	disableOmsService?: boolean;
	disableCustomerManagementService?: boolean;

	constructor(@Optional() @Inject(CORE_CONFIG) coreConfig: CoreConfigModel) {
		Object.assign(this, coreConfig);
	}
}
